export default __webpack_public_path__ + "static/media/agencyFees.d8f80a00.svg";